module.exports = __webpack_public_path__ + "img/character.290a5bc1.png";